// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"868":"6ed0034c","1935":"4a480004","2079":"6ed0034c","4235":"4a480004","4496":"4a480004","4804":"8928e76d","9212":"4a480004"}[chunkId] + ".chunk.css";
};